import React, { useState } from 'react';
import { Box, TextField, Alert } from '@mui/material';
import UIButton from 'components/ui/UIButton';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { feedbackActions } from 'features/feedback/store/feedback.slice';

const IdeaForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const formState = useAppSelector((s) => s.feedback.formState);
  const errorMessage = useAppSelector((s) => s.feedback.errorMessage);
  const submitting = formState === 'submitting';
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [touched, setTouched] = useState(false);
  const titleErr = touched && !title.trim();
  const descErr = touched && !description.trim();

  const onSubmit = () => {
    setTouched(true);
    if (!title.trim() || !description.trim()) return;
    dispatch(feedbackActions.submit({ type: 'IDEA', title: title.trim(), description: description.trim() }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert icon={false} severity="success" sx={{ fontSize: 13, background: 'rgba(39,204,188,.10)', color: '#12897d' }}>
        🌐 Публічна — з&apos;явиться на дошці ідей, інші зможуть голосувати.
      </Alert>
      {formState === 'error' && <Alert severity="error">{errorMessage || 'Не вдалося надіслати. Спробуй ще раз.'}</Alert>}
      <TextField label="Назва ідеї" value={title} onChange={(e) => setTitle(e.target.value)} error={titleErr} helperText={titleErr ? 'Додай назву' : ''} fullWidth inputProps={{ maxLength: 200 }} />
      <TextField label="Опиши детальніше" value={description} onChange={(e) => setDescription(e.target.value)} error={descErr} helperText={descErr ? 'Опиши ідею' : ''} multiline minRows={3} fullWidth inputProps={{ maxLength: 5000 }} />
      <UIButton fullWidth variant="contained" disabled={submitting} onClick={onSubmit}>
        {submitting ? 'Надсилаємо…' : 'Надіслати'}
      </UIButton>
    </Box>
  );
};

export default IdeaForm;
